import React from 'react';

export default function OliAiIcon({ className, applyDarkFilter = false }) {
  return (
    <img
      src="/assets/branding/oli-ai-white.png"
      alt="Oli AI"
      className={className}
      style={
        applyDarkFilter
          ? {
              filter: "brightness(0.3) saturate(1.5)",
            }
          : {}
      }
    />
  );
}